<template>
  <div v-show="show" class="nuttrema-notification" :class="[ theme ? `theme-${theme}` : '' ]">

    <div v-if="options.icon" class="nuttrema-notification__bg">
      <i :class="[options.icon]"></i>
    </div>

    <div class="nuttrema-notification_top">

      <div v-if="options.title" class="nuttrema-notification__title" v-html="_markdown.render(options.title)"></div>
      <div v-if="options.subTitle" class="nuttrema-notification__sub-title" v-html="_markdown.render(options.subTitle)"></div>

      <span v-if="closable" class="nuttrema-notification__close" :title="$t('label.close')" @click="show = false">
        <i class="far fa-times"></i>
      </span>
    </div>

  </div>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'nuttrema-notification',
  props: {
    svg: String,
    icon: String,
    title: String,
    theme: String,
    subTitle: String,
    closable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      show: true,
      options: {
        icon: null,
        svg: null,
        title: null,
        subTitle: null,
      },
      themes: {
        success: {
          icon: 'fas fa-check',
          title: 'label.default_success_title',
        },
        info: {
          icon: 'far fa-info',
          title: 'label.default_information_title',
        },
        warning: {
          icon: 'far fa-exclamation',
          title: 'label.default_warning_title',
        },
        danger: {},
      },
    };
  },
  methods: {
    close() {
      this.show = false;
      this.$emit('close');
    },
    applyTheme(name) {
      const theme = get(this.themes, name);

      this.options.svg = this.svg || get(theme, 'svg');
      this.options.icon = this.icon || get(theme, 'icon');
      this.options.title = this.title || get(theme, 'title');
      this.options.subTitle = this.subTitle || get(theme, 'subTitle');
    },
  },
  created() {
    if (this.theme) this.applyTheme(this.theme);
  },
  watch: {
    title() {
      this.applyTheme(this.theme);
    },
    subTitle() {
      this.applyTheme(this.theme);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import './nuttrema-alert-colors';

  .nuttrema-notification {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    position: relative;

    min-height: 5em;
    align-items: center;
    border-radius: 0.5em;
    padding: 1em 1.5em 1.25em 1.5em;

    .nuttrema-notification__bg {
      z-index: 0;
      position: absolute;
      top: 0; right: 0; left: 0; bottom: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      > i {
        display: flex;
        font-size: 12rem;
      }
    }

    .nuttrema-notification_top {
      z-index: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    .nuttrema-notification__title, .nuttrema-notification__sub-title {
      align-self: stretch;
      p {
        margin: 0;
      }
    }

    .nuttrema-notification__title {
      line-height: 1.35;
      font-weight: 500;
    }

    .nuttrema-notification__sub-title {
      line-height: 1.25;
      font-size: 0.95rem;
      p {
        margin-bottom: 0.5em;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .nuttrema-notification__close {
      top: 0.75em;
      right: 1em;
      line-height: 1;
      position: absolute;
      &:hover {
        cursor: pointer;
      }
    }

    // &.is-info {
    //   background-color: $info-bg-color;
    //   .nuttrema-notification__bg {
    //     > i {
    //       color: darken($info-bg-color, 2%);
    //     }
    //   }
    // }

    // &.is-blue {
    //   color: $blue-color;
    //   background-color: $blue-bg-color;
    //   .nuttrema-notification__bg {
    //     > i {
    //       color: darken($blue-bg-color, 2%);
    //     }
    //   }
    // }

    // &.is-dark-orange {
    //   color: $dark-orange-color;
    //   background-color: $dark-orange-bg-color;
    //   .nuttrema-notification__bg {
    //     > i {
    //       color: $dark-orange-icon-color;
    //     }
    //   }
    // }

    // &.is-orange {
    //   color: $orange-color;
    //   background-color: $orange-bg-color;
    //   .nuttrema-notification__bg {
    //     > i {
    //       color: $orange-icon-color;
    //     }
    //   }
    // }

    // &.is-pink {
    //   color: $pink-color;
    //   background-color: $pink-bg-color;
    //   .nuttrema-notification__bg {
    //     > i {
    //       color: $pink-icon-color;
    //     }
    //   }
    // }

    &.theme-success {
      color: $success-color;
      background-color: $success-bg-color;
      .nuttrema-notification__bg {
        > i {
          color: darken($success-bg-color, 5%);
        }
      }
    }

    &.theme-info {
      color: $info-color;
      background-color: $info-bg-color;
      .nuttrema-notification__bg {
        padding-right: 2.5em;
        > i {
          font-size: 6em;
        }
      }
    }

    &.theme-warning {
      color: $warning-color;
      background-color: $warning-bg-color;
      .nuttrema-notification__bg {
        > i {
          color: $warning-icon-color;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/alert/nuttrema-notification.vue